import React from "react";
import CommunityAddPage from "../community/components/CommunityAddPage";
import { OTHER_REQUESTS } from "../community/constants";
import { useRequireSectionVisible } from "../../client/hooks/useRequireSectionVisible";

export default function AddOtherRequestsPage() {
  useRequireSectionVisible("showOtherRequests");
  return <CommunityAddPage section={OTHER_REQUESTS} />;
}
